import { NgModule } from '@angular/core';
import { MatButtonModule, MatDialogModule, MatTabsModule } from '@angular/material';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from "@app/shared";
import { AuthenticationGuard as AuthGuard } from '@app/shared/services/authguards';
import {
  MyLeadTaskListComponent,
  MyRawLeadAddRawLeadsNotesModalComponent
} from '@my-tasks/components/sales/my-sales';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';

const routes: Routes = [
  { path: '', component: MyLeadTaskListComponent, data: { title: 'My Leads Dashboard' }, canActivate: [AuthGuard] },
  {
    path: 'my-leads', loadChildren: () => import('../../../../../modules/sales/components/task-management/task-management.module').then(m => m.TaskManagementModule)
  },
  {
    path: 'leads/service-agreement', loadChildren: () => import('../../../../../modules/sales/components/task-management/service-installation-agreement/service-sales-installation-agreement.module').then(m => m.ServiceSalesInstallationAgreementModule)
  },
  {
    path: 'leads/installation-agreement', loadChildren: () => import('../../../../../modules/sales/components/task-management/service-installation-agreement/service-sales-installation-agreement.module').then(m => m.ServiceSalesInstallationAgreementModule)
  },
  {
    path: 'my-unqualified-leads', loadChildren: () => import('../../../../../modules/sales/components/raw-lead/raw-lead.module').then(m => m.RawLeadModule)
  },
  {
    path: 'my-stop-and-knocks', loadChildren: () => import('../../../../../modules/sales/components/stop-and-knock/stop-and-knock.module').then(m => m.StopAndKnockModule)
  }
];

@NgModule({
  declarations: [MyLeadTaskListComponent, MyRawLeadAddRawLeadsNotesModalComponent],
  imports: [RouterModule.forChild(routes),
    SharedModule, MatTabsModule, CalendarModule, DropdownModule, MatDialogModule, TableModule, MatDialogModule, MatButtonModule],
  entryComponents: [MyRawLeadAddRawLeadsNotesModalComponent]
})
export class MySalesModule { }